// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"styles_iconContainer__24r5r","icon":"styles_icon__124X9","icon--black":"styles_icon--black__15_Ua","iconContainer--red":"styles_iconContainer--red__37rRk"};